export default __webpack_public_path__ + "static/media/cattleytics-logo-dark-with-tagline.e4c023ab.png";